<div class="feature__container">
    <div class="feature__logo">
        <img [src]=capability.capability_icon_url>
    </div>
    <div class="feature__title">
        {{capability.name}}
    </div>
    <div class="feature__description">
        {{capability.description}}
    </div>
</div>
